<template>
	<Layout>
		<div class="rwt-contact-area rn-section-gap">
			<div class="container">
				<div class="row">
					<div class="col-lg-12 mb--40">
						<SectionTitle text-align="center" subtitle="Contact Us" title="联 系 我 们" />
					</div>
				</div>
				
				<div class="row row--15">
				    <div class="col-lg-12">
				        <div class="rn-contact-address mt_dec--30">
				            <div class="row">
				                <div class="col-lg-4 col-md-6 col-12">
				                    <div class="rn-address">
				                        <div class="icon">
				                            <Icon name="headphones" :size="40"/>
				                        </div>
				                        <div class="inner">
				                            <h4 class="title">联系电话</h4>
				                            <p><a href="tel:+444 555 666 777">销售热线：0411-62682889</a></p>
				                            <p><a href="tel:+222 222 222 333">技术支持(座机)：0411-62682868</a></p>
																		<p><a href="tel:+222 222 222 333">技术支持(手机)：13154116146</a></p>
				                        </div>
				                    </div>
				                </div>
				
				                <div class="col-lg-4 col-md-6 col-12">
				                    <div class="rn-address">
				                        <div class="icon">
				                            <Icon name="mail" :size="40"/>
				                        </div>
				                        <div class="inner">
				                            <h4 class="title">E-mail</h4>
				                            <p><a href="mailto:admin@gmail.com">dcce62682888@163.com</a></p>
				                        </div>
				                    </div>
				                </div>
				
				                <div class="col-lg-4 col-md-6 col-12">
				                    <div class="rn-address">
				                        <div class="icon">
				                            <Icon name="map-pin" :size="40"/>
				                        </div>
				                        <div class="inner">
				                            <h4 class="title">总部地址</h4>
				                            <p>辽宁省大连市旅顺口区盐北路706号 <br /> 邮编：116045</p>
				                        </div>
				                    </div>
				                </div>
				            </div>
				        </div>
				    </div>
				</div>
				
			</div>
		</div>
	</Layout>
</template>

<script>
	import Layout from '../components/common/Layout'
	import SectionTitle from "../components/elements/sectionTitle/SectionTitle"
	import Icon from "../components/icon/Icon"

	export default {
		name: 'ContactUsPage',
		components: {
			Layout,SectionTitle,Icon
		}
	}
</script>

<style>
</style>
